import { MappingItem } from '@corratech/pylot-gtm/src/GTM'
import { pdpItemMapping } from 'stores/ooka_usa_store/components/OOKA/pylot-gtm/src/mapping/events/pdpItemMapping'

export const pdpCrossSellProductsData = (
    itemMapping = pdpItemMapping()
): MappingItem => {
    return {
        crosssell_products_list: {
            data_source: ['crosssell_products'],
            mapping: itemMapping,
            strict: true
        }
    }
}
